<div class="container">
  <div class="team">
    <div class="team__content">
      <h2 class="team__content__header">{{ header }}</h2>
      <p *ngIf="description" class="team__content__description">{{ description }}</p>
      <div class="team__content__team-members">
        <app-person
          *ngFor="let member of allPersons"
          name="{{ member.name }}"
          position="{{ member.position }}"
          image="{{ member.image }}"
          phone="{{ member.phone }}"
          email="{{ member.email }}"
        ></app-person>
      </div>
    </div>
  </div>
</div>
